/*
 * Google Analytics 4. Only runs on the live site (production build); on the
 * dev server nothing is sent.
 *
 * Page views (including /about, /contact and song pages) are counted by GA
 * itself: keep "Page changes based on browser history events" on, under
 * Admin → Data streams → Enhanced measurement.
 *
 * Custom events sent with track() (see each file for where):
 *   stream_click   { song, platform }     a streaming button on a song page
 *   preview_play   { song, track? }       a preview started (home or song page)
 *   share          { method, song }       the song page's Share button
 *   contact_email  { method }             email copied or clicked (Contact)
 *   social_click   { platform, place }    a follow icon
 *   photo_flip                           the About photo turned over
 */
const GA_ID = "G-FG17HQXDVH"; // Measurement ID (public, safe to commit)

// Only the real site counts: not the dev server, and not the beta branch
// (beta--….netlify.app) or other test copies
const LIVE_HOSTS = ["thangcao.me", "www.thangcao.me"];
const enabled =
  Boolean(GA_ID) &&
  process.env.NODE_ENV === "production" &&
  LIVE_HOSTS.includes(window.location.hostname);

export function setUpAnalytics() {
  if (!enabled) return;
  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments); // eslint-disable-line prefer-rest-params
  };
  window.gtag("js", new Date());
  window.gtag("config", GA_ID);

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(script);
}

export function track(name, params = {}) {
  if (enabled) window.gtag?.("event", name, params);
}
